// Enemy.js - How enemies look

export const drawEnemy = (ctx, enemy, isPlayerImmune, spaceBearImage) => {
  // Use space bear image for both horizontal and stationary enemies
  if (spaceBearImage) {
    ctx.save();
    
    // Apply floating offset to Y position
    const drawY = enemy.y + (enemy.floatOffset || 0);
    const centerX = enemy.x + enemy.w / 2;
    const centerY = drawY + enemy.h / 2;
    
    ctx.translate(centerX, centerY);
    
    // Flip based on facing direction
    if (enemy.type === 'horizontal') {
      // Horizontal enemies: flip when moving right
      if (enemy.direction === 1) {
        ctx.scale(-1, 1);
      }
    } else {
      // Stationary enemies: use random facing direction
      if (enemy.facingRight) {
        ctx.scale(-1, 1);
      }
    }
    
    // Draw the bear centered
    ctx.drawImage(spaceBearImage, -enemy.w / 2, -enemy.h / 2, enemy.w, enemy.h);
    
    ctx.restore();
    return; // Done drawing, exit
  }
  
  // Fallback: draw the normal spiky enemy (if image not loaded)
  const drawY = enemy.y + (enemy.floatOffset || 0);
  
  // Color based on health
  if (enemy.maxHealth === 5) {
    ctx.fillStyle = '#8B0000'; // Dark red for 5-hit enemies
  } else if (enemy.maxHealth === 3) {
    ctx.fillStyle = '#FF4444'; // Medium red for 3-hit enemies
  } else {
    ctx.fillStyle = '#FF3333'; // Normal red
  }
  
  // Draw spiky body
  ctx.beginPath();
  const cx = enemy.x + enemy.w/2;
  const cy = drawY + enemy.h/2;
  const r = enemy.w/2;
  
  for (let i = 0; i < 8; i++) {
    const angle = (i / 8) * Math.PI * 2;
    const spikeR = i % 2 === 0 ? r : r * 1.3;
    const x = cx + Math.cos(angle) * spikeR;
    const y = cy + Math.sin(angle) * spikeR;
    if (i === 0) ctx.moveTo(x, y);
    else ctx.lineTo(x, y);
  }
  ctx.closePath();
  ctx.fill();
  
  // Draw eye (white circle)
  ctx.fillStyle = '#FFF';
  ctx.beginPath();
  ctx.arc(cx, cy, r * 0.4, 0, Math.PI * 2);
  ctx.fill();
  
  // Draw pupil (black circle)
  ctx.fillStyle = '#000';
  ctx.beginPath();
  ctx.arc(cx, cy, r * 0.2, 0, Math.PI * 2);
  ctx.fill();
};

export const drawAllEnemies = (ctx, enemies, isPlayerImmune, spaceBearImage) => {
  enemies.forEach(enemy => {
    drawEnemy(ctx, enemy, isPlayerImmune, spaceBearImage);
  });
};